import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-security-compliance',
    templateUrl: './security-compliance.component.html',
    styleUrls: ['./security-compliance.component.scss']
})
export class SecurityComplianceComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
